module.exports = __webpack_public_path__ + "img/maximize-01.c1c2f903.svg";